"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STREAM_STOP_FAILED = exports.STREAM_STOPPING = exports.STREAM_STOPPED = exports.STREAM_START_FAILED = exports.STREAM_STARTING = exports.STREAM_PRE_BROADCAST = exports.STREAM_POST_BROADCAST = exports.STREAM_INACTIVE = exports.STREAM_ACTIVE = exports.STOPPING = exports.STOPPED = exports.STARTING = exports.STARTED = exports.PENDING = void 0;
/** @deprecated **/
var STREAM_PRE_BROADCAST = exports.STREAM_PRE_BROADCAST = 'STREAM_PRE_BROADCAST'; // more than 5 minutes before start
var STREAM_INACTIVE = exports.STREAM_INACTIVE = 'STREAM_INACTIVE'; // we're within the broadcast window but no streaming
var STREAM_STARTING = exports.STREAM_STARTING = 'STREAM_STARTING'; // we're starting stream
var STREAM_START_FAILED = exports.STREAM_START_FAILED = 'STREAM_START_FAILED'; // stream failed start
var STREAM_ACTIVE = exports.STREAM_ACTIVE = 'STREAM_ACTIVE'; // we're streaming
var STREAM_STOPPING = exports.STREAM_STOPPING = 'STREAM_STOPPING'; // we're stopping streaming
var STREAM_STOPPED = exports.STREAM_STOPPED = 'STREAM_STOPPED'; // we're stopped streaming
var STREAM_STOP_FAILED = exports.STREAM_STOP_FAILED = 'STREAM_STOP_FAILED'; // stream failed stop
var STREAM_POST_BROADCAST = exports.STREAM_POST_BROADCAST = 'STREAM_POST_BROADCAST'; // we're past broadcast window
/** @deprecated **/

var PENDING = exports.PENDING = 'PENDING';
var STARTING = exports.STARTING = 'STARTING';
var STARTED = exports.STARTED = 'STARTED';
var STOPPING = exports.STOPPING = 'STOPPING';
var STOPPED = exports.STOPPED = 'STOPPED';